import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['formSection']

  scrollToFormSection () {
    this.formSectionTarget.scrollIntoView({ behavior: 'smooth' })
  }
}
